/*
  NIVELLE CUSTOM CODE: Trade application wizard (Oct 2 2026). Used by sections/nivelle-trade-application.liquid.
  Listed in Trello "REFERENCE: Custom code map". All wording comes from the section settings (data-nvta-config).
  1. Builds the dropdowns / checkboxes from the "one choice per line" settings.
  2. Shows one step at a time, checks required fields before moving on.
  3. Saves answers in the browser as they go (localStorage) and offers "Start over".
  4. Klaviyo: "Trade Application Started" after step 1, "Trade Application Submitted" + optional list sign-up at the end.
  5. Sends the finished application to the Cloudflare Worker (/apply), which creates or updates the Shopify customer.
  Oct 5 2026 fixes (Claude):
  a. List sign-up: removed "subscriptions" from the profile (Klaviyo rejected the whole sign-up with error 400 on this API version).
  b. Klaviyo or the Worker: the application counts as sent if EITHER Klaviyo or the Cloudflare Worker (/apply) accepts it
     (ad blockers often block a.klaviyo.com). If both fail, the visitor sees the error message with the sales@ email.
     (Shopify's own /contact form can't be used as a backup: it requires an hCaptcha token, tested Oct 5.)
  c. Bot trap renamed to "nvta_hp" on page load (browser autofill could fill the old "company_fax" field, which silently stopped
     real applications). A filled trap now only counts as a bot if the form was also finished in under 8 seconds.
*/
(function () {
  var COUNTRIES = [['US','United States'],['CA','Canada'],['GB','United Kingdom'],['AU','Australia'],['AE','United Arab Emirates'],
    ['IN','India'],['IL','Israel'],['MX','Mexico'],['BS','Bahamas'],['AW','Aruba'],['SX','Sint Maarten'],['MF','Saint Martin'],
    ['VI','U.S. Virgin Islands'],['VG','British Virgin Islands'],['KY','Cayman Islands'],['PR','Puerto Rico'],['JM','Jamaica'],
    ['BM','Bermuda'],['BR','Brazil'],['FR','France'],['DE','Germany'],['IT','Italy'],['ES','Spain'],['NL','Netherlands'],
    ['BE','Belgium'],['CH','Switzerland'],['IE','Ireland'],['SE','Sweden'],['HK','Hong Kong'],['SG','Singapore'],['JP','Japan'],
    ['KR','South Korea'],['SA','Saudi Arabia'],['QA','Qatar'],['KW','Kuwait'],['ZA','South Africa'],['NZ','New Zealand']];
  var PROVINCES = {
    US: 'AL Alabama|AK Alaska|AZ Arizona|AR Arkansas|CA California|CO Colorado|CT Connecticut|DE Delaware|DC District of Columbia|FL Florida|GA Georgia|HI Hawaii|ID Idaho|IL Illinois|IN Indiana|IA Iowa|KS Kansas|KY Kentucky|LA Louisiana|ME Maine|MD Maryland|MA Massachusetts|MI Michigan|MN Minnesota|MS Mississippi|MO Missouri|MT Montana|NE Nebraska|NV Nevada|NH New Hampshire|NJ New Jersey|NM New Mexico|NY New York|NC North Carolina|ND North Dakota|OH Ohio|OK Oklahoma|OR Oregon|PA Pennsylvania|PR Puerto Rico|RI Rhode Island|SC South Carolina|SD South Dakota|TN Tennessee|TX Texas|UT Utah|VT Vermont|VA Virginia|WA Washington|WV West Virginia|WI Wisconsin|WY Wyoming',
    CA: 'AB Alberta|BC British Columbia|MB Manitoba|NB New Brunswick|NL Newfoundland and Labrador|NS Nova Scotia|NT Northwest Territories|NU Nunavut|ON Ontario|PE Prince Edward Island|QC Quebec|SK Saskatchewan|YT Yukon'
  };
  var REV = '2024-10-15';
  var TRAP = 'nvta_hp';

  function init(root) {
    var cfgEl = root.parentNode.querySelector('[data-nvta-config]') || document.querySelector('[data-nvta-config]');
    var cfg = JSON.parse(cfgEl.textContent);
    var t = cfg.t;
    var form = root.querySelector('[data-nvta-form]');
    var steps = [].slice.call(form.querySelectorAll('.nvta__step'));
    var bar = root.querySelector('[data-nvta-bar]');
    var count = root.querySelector('[data-nvta-count]');
    var err = root.querySelector('[data-nvta-error]');
    var btnBack = root.querySelector('[data-nvta-back]');
    var btnNext = root.querySelector('[data-nvta-next]');
    var btnSubmit = root.querySelector('[data-nvta-submit]');
    var resume = root.querySelector('[data-nvta-resume]');
    var current = 0;
    var startedAt = Date.now();
    var hp = form.querySelector('.nvta__hp'); if (hp) { hp.name = TRAP; hp.value = ''; }   // rename the bot trap before autofill runs (fix c)

    // 1. Build choices from settings
    function lines(s) { return String(s || '').split(/\r?\n/).map(function (x) { return x.trim(); }).filter(Boolean); }
    form.querySelectorAll('select[data-nvta-options]').forEach(function (sel) {
      sel.innerHTML = '<option value="">' + esc(t.select) + '</option>' +
        lines(sel.getAttribute('data-nvta-options')).map(function (o) { return '<option>' + esc(o) + '</option>'; }).join('');
    });
    form.querySelectorAll('[data-nvta-checks]').forEach(function (box) {
      var name = box.getAttribute('data-nvta-checks');
      box.innerHTML = lines(box.getAttribute('data-nvta-options')).map(function (o) {
        return '<label class="nvta__check"><input type="checkbox" name="' + name + '" value="' + esc(o) + '"> <span>' + esc(o) + '</span></label>';
      }).join('');
    });
    var country = form.querySelector('[data-nvta-country]');
    var prov = form.querySelector('[data-nvta-province]');
    var provText = form.querySelector('[data-nvta-province-text]');
    country.innerHTML = '<option value="">' + esc(t.select) + '</option>' +
      COUNTRIES.map(function (c) { return '<option value="' + c[0] + '">' + esc(c[1]) + '</option>'; }).join('') +
      '<option value="OTHER">' + esc(t.other_country) + '</option>';
    function syncProvince() {
      var list = PROVINCES[country.value];
      if (list) {
        var keep = prov.value;
        prov.innerHTML = '<option value="">' + esc(t.select) + '</option>' + list.split('|').map(function (p) {
          return '<option value="' + p.slice(0, 2) + '">' + esc(p.slice(3)) + '</option>'; }).join('');
        prov.value = keep; prov.hidden = false; provText.hidden = true;
      } else { prov.hidden = true; prov.value = ''; provText.hidden = false; }
    }
    country.addEventListener('change', syncProvince);

    // 3. Save / restore
    function read() {
      var data = {};
      [].forEach.call(form.elements, function (el) {
        if (!el.name || el.name === TRAP) return;
        if (el.type === 'checkbox') {
          if (el.name === 'consent') { data.consent = el.checked; return; }
          data[el.name] = data[el.name] || [];
          if (el.checked) data[el.name].push(el.value);
        } else { data[el.name] = (el.value || '').trim(); }
      });
      return data;
    }
    function save() { try { localStorage.setItem(cfg.storageKey, JSON.stringify({ step: current, data: read(), at: Date.now() })); } catch (e) {} }
    function restore() {
      var saved = null;
      try { saved = JSON.parse(localStorage.getItem(cfg.storageKey) || 'null'); } catch (e) {}
      var filled = saved && saved.data && Object.keys(saved.data).some(function (k) {
        var v = saved.data[k]; return k !== 'consent' && (Array.isArray(v) ? v.length : !!v); });
      if (!filled) {
        if (cfg.customer) ['email', 'first_name', 'last_name', 'phone'].forEach(function (k) { if (cfg.customer[k] && form.elements[k]) form.elements[k].value = cfg.customer[k]; });
        return 0;
      }
      var d = saved.data;
      if (d.country) { country.value = d.country; syncProvince(); }
      Object.keys(d).forEach(function (k) {
        var v = d[k];
        if (k === 'consent') { if (form.elements.consent) form.elements.consent.checked = !!v; return; }
        if (Array.isArray(v)) { form.querySelectorAll('input[name="' + k + '"]').forEach(function (c) { c.checked = v.indexOf(c.value) > -1; }); return; }
        var el = form.elements[k]; if (el && el.tagName) el.value = v;
      });
      resume.hidden = false;
      return Math.min(saved.step || 0, steps.length - 1);
    }
    form.addEventListener('input', save);
    form.addEventListener('change', save);
    root.querySelector('[data-nvta-reset]').addEventListener('click', function () {
      try { localStorage.removeItem(cfg.storageKey); localStorage.removeItem(cfg.storageKey + '_started'); } catch (e) {}
      form.reset(); syncProvince(); resume.hidden = true; show(0);
    });

    // 2. Steps
    function show(i) {
      current = i;
      steps.forEach(function (s, n) { s.hidden = n !== i; });
      btnBack.hidden = i === 0;
      btnNext.hidden = i === steps.length - 1;
      btnSubmit.hidden = i !== steps.length - 1;
      bar.style.width = Math.round(((i + 1) / steps.length) * 100) + '%';
      count.textContent = t.step.replace('[n]', i + 1).replace('[total]', steps.length);
      err.textContent = '';
      save();
    }
    function check(i) {
      var step = steps[i];
      var bad = null;
      step.querySelectorAll('[required]').forEach(function (el) {
        var ok = el.value.trim() !== '';
        el.classList.toggle('is-invalid', !ok);
        if (!ok && !bad) bad = el;
      });
      if (bad) { err.textContent = t.required; bad.focus(); return false; }
      var email = step.querySelector('input[type=email]');
      if (email && !/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(email.value.trim())) { email.classList.add('is-invalid'); err.textContent = t.email; email.focus(); return false; }
      var oneOf = step.querySelectorAll('[data-nvta-oneof]');
      if (oneOf.length && ![].some.call(oneOf, function (el) { return el.value.trim(); })) {
        oneOf.forEach(function (el) { el.classList.add('is-invalid'); }); err.textContent = t.online; oneOf[0].focus(); return false;
      }
      var group = step.querySelector('[data-nvta-required-group]');
      if (group && !group.querySelector('input:checked')) { err.textContent = t.interests; return false; }
      return true;
    }
    btnNext.addEventListener('click', function () {
      if (!check(current)) return;
      if (current === 0) started();
      show(current + 1);
      root.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
    btnBack.addEventListener('click', function () { show(current - 1); });

    // 4. Klaviyo
    function klaviyo(path, body) {
      if (!cfg.klaviyoKey) return Promise.resolve({ ok: true, status: 202 });
      return fetch('https://a.klaviyo.com/client/' + path + '/?company_id=' + encodeURIComponent(cfg.klaviyoKey), {
        method: 'POST', headers: { 'Content-Type': 'application/json', revision: REV }, body: JSON.stringify(body)
      });
    }
    function e164(p) {
      var d = String(p || '').replace(/[^\d+]/g, '');
      if (/^\+\d{8,15}$/.test(d)) return d;
      d = d.replace(/\D/g, '');
      if (d.length === 10) return '+1' + d;
      if (d.length === 11 && d[0] === '1') return '+' + d;
      return '';
    }
    function profileFrom(d, props) {
      var attrs = { email: d.email, first_name: d.first_name, last_name: d.last_name, properties: props };
      if (d.company) attrs.organization = d.company;
      if (d.role) attrs.title = d.role;
      var ph = e164(d.phone); if (ph) attrs.phone_number = ph;
      if (d.city || d.country || d.address1) attrs.location = { address1: d.address1, address2: d.address2, city: d.city,
        region: d.province || d.province_text, zip: d.zip, country: d.country && d.country !== 'OTHER' ? d.country : '' };
      return { type: 'profile', attributes: attrs };
    }
    function props(d, stage) {
      return {
        account_stage: stage, lead_source: d.lead_source || 'Website', phone_entered: d.phone, role: d.role,
        company: d.company, business_type: d.business_type, locations: d.locations, years_in_business: d.years_in_business,
        website: d.website, social: d.social, city: d.city, state: d.province || d.province_text, country: d.country,
        interests: d.interests, categories: d.categories, price_point: d.price_point, est_first_order: d.est_first_order,
        timing: d.timing, resale_id: d.resale_id, jbt_number: d.jbt_number, other_brands: d.other_brands,
        references: d.references, application_message: d.message, wants_updates: !!d.consent, page: cfg.pageUrl
      };
    }
    function started() {
      var d = read();
      var flag = cfg.storageKey + '_started';
      try { if (localStorage.getItem(flag) === d.email) return; localStorage.setItem(flag, d.email); } catch (e) {}
      var p = props(d, 'Started');
      klaviyo('events', { data: { type: 'event', attributes: {
        metric: { data: { type: 'metric', attributes: { name: 'Trade Application Started' } } },
        profile: { data: profileFrom(d, { trade_application_status: 'Started' }) }, properties: p } } }).catch(function () {});
    }

    function finish() {
      try { localStorage.removeItem(cfg.storageKey); } catch (e) {}
      form.hidden = true; resume.hidden = true; count.hidden = true; bar.parentNode.hidden = true;
      var done = root.querySelector('[data-nvta-done]'); done.hidden = false; done.focus();
    }

    // 5. Submit
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      var trap = form.elements[TRAP];
      if (trap && trap.value && (Date.now() - startedAt) < 8000) { finish(); return; }   // bot: filled the hidden field and finished in seconds
      for (var i = 0; i < steps.length; i++) { if (!check(i)) { show(i); check(i); return; } }
      var d = read();
      var p = props(d, 'Applied');
      p.applied_at = new Date().toISOString();
      err.textContent = t.sending; btnSubmit.disabled = true;
      var soft = function () { return { ok: false, soft: true }; };
      var calls = [klaviyo('events', { data: { type: 'event', attributes: {
        metric: { data: { type: 'metric', attributes: { name: 'Trade Application Submitted' } } },
        profile: { data: profileFrom(d, { trade_application_status: 'Applied', trade_applied_at: p.applied_at }) },
        properties: p, unique_id: 'trade-app-' + d.email + '-' + p.applied_at.slice(0, 16) } } }).then(null, soft)];
      if (d.consent && cfg.klaviyoListId) {
        calls.push(klaviyo('subscriptions', { data: { type: 'subscription', attributes: {
          custom_source: 'Trade Application Form',
          profile: { data: { type: 'profile', attributes: { email: d.email } } }
        }, relationships: { list: { data: { type: 'list', id: cfg.klaviyoListId } } } } }).then(null, soft));
      }
      if (cfg.serviceUrl) {
        var body = Object.assign({}, d, { tag: cfg.tag, seconds: Math.round((Date.now() - startedAt) / 1000), page: cfg.pageUrl });
        calls.push(fetch(cfg.serviceUrl.replace(/\/+$/, '') + '/apply', {
          method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(body)
        }).then(function (r) { return r; }, soft));
      }
      Promise.all(calls).then(function (res) {
        // Klaviyo is the record of truth; the Worker (Shopify customer) also counts, so one blocked service doesn't lose the lead.
        var shop = cfg.serviceUrl ? res[res.length - 1] : null;
        if (res[0].ok || res[0].status === 202 || (shop && shop.ok)) return finish();
        throw new Error('not sent');
      }).catch(function () { err.textContent = t.failed; btnSubmit.disabled = false; });
    });

    function esc(s) { return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }

    show(restore());
  }

  function boot() { document.querySelectorAll('.nvta').forEach(function (root) { if (!root.__nvta) { root.__nvta = 1; init(root); } }); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
